var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgESignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3055",
    "data-name": "Rectangle 3055",
    width: 21,
    height: 21,
    fill: "#5a5a5a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10557",
    "data-name": "Group 10557",
    transform: "translate(0 0.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10556",
    "data-name": "Group 10556",
    transform: "translate(0 -0.371)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28898",
    "data-name": "Path 28898",
    d: "M21.4,4.641a3.844,3.844,0,0,0-6.563-2.718L3.353,13.409a.759.759,0,0,0-.053.059l-.011.015c-.012.016-.024.032-.035.049l-.011.019c-.01.016-.019.033-.027.05l-.01.021c-.008.017-.015.034-.021.051l0,.012L.841,20.433a.726.726,0,0,0,.924.924l6.749-2.339.012,0,.051-.021.021-.01.05-.027.019-.011c.016-.011.033-.022.049-.034L8.73,18.9q.031-.025.059-.053L19.35,8.284h0l.924-.924A3.819,3.819,0,0,0,21.4,4.641M8.276,17.3,4.893,13.922l9.535-9.535L17.811,7.77Zm-4.1-2.05,2.77,2.77L2.7,19.495ZM19.248,6.333l-.411.411L15.454,3.36l.411-.411a2.392,2.392,0,1,1,3.383,3.383",
    transform: "translate(-0.757 -0.441)",
    fill: "#5a5a5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgESignatureIcon);
export default __webpack_public_path__ + "static/media/eSignature-icon.b2be1763cfee071a7210135e5027311e.svg";
export { ForwardRef as ReactComponent };